import { render, staticRenderFns } from "./LandingFactoringReg3.vue?vue&type=template&id=2a58be65&"
import script from "./LandingFactoringReg3.vue?vue&type=script&lang=ts&"
export * from "./LandingFactoringReg3.vue?vue&type=script&lang=ts&"
import style0 from "./LandingFactoringReg3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports